import { EmptyStateStyles } from "./emptyState.styles";

const EmptyState = ({ icon, title, subtitle, className }) => (
  <EmptyStateStyles className={className}>
    {icon && <div className="es-icon">{icon}</div>}
    {title && <p className="es-title">{title}</p>}
    {subtitle && <p className="es-subtitle">{subtitle}</p>}
  </EmptyStateStyles>
);

export default EmptyState;
